/* Sassy Scents — Verhalten für die neuen Sections.
   Einbinden am Ende von layout/theme.liquid:
     <script src="{{ 'sassy-theme.js' | asset_url }}" defer></script>
   Keine Abhängigkeiten. Alles greift nur, wenn das jeweilige Markup da ist. */
(function () {
  'use strict';

  var money = function (cents) {
    var f = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: f }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* Section, aus der der Cart-Drawer sein Markup zieht (Horizon). */
  var DRAWER_SECTION = 'cart-drawer-section';

  /* Wird in Block 3b belegt, sobald es eine Sticky-Leiste gibt. Block 1 ruft
     es beim Klick auf - deklariert also hier oben, obwohl es weiter unten
     entsteht. */
  var sassySyncSticky = null;

  /* Die Warenkorbseite ist eine eigene, statische Section: nach einem Quick
     add zeigte sie sonst weiter die alten Positionen und die alte Summe,
     waehrend der Warenkorb laengst mehr enthaelt. Ihre ID steht im Markup,
     damit wir sie im selben Roundtrip mitrendern lassen koennen. */
  function cartPageId() {
    var el = document.querySelector('[data-sassy-cart-section]');
    return el ? el.getAttribute('data-sassy-cart-section') : null;
  }

  /* Section Rendering API liefert die Section samt Wrapper-DIV. Wir setzen
     deshalb den Inhalt, nicht das Ganze - sonst steckt der Wrapper doppelt
     im Dokument und die naechste Aktualisierung findet ihn nicht wieder. */
  function renderCartPage(sections, pageId) {
    if (!sections || !pageId) return;
    var html = sections[pageId];
    if (!html) return;
    var host = document.getElementById('shopify-section-' + pageId);
    if (!host) return;
    try {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.getElementById('shopify-section-' + pageId);
      host.innerHTML = fresh ? fresh.innerHTML : html;
    } catch (e) { /* Seite bleibt stehen; reconcileCount korrigiert das Badge. */ }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  /* Horizon hoert auf 'shopify:cart:lines-update' und erwartet ein Event mit
     .action und .promise -> { cart, detail }. Genau das bauen wir hier nach,
     damit Cart-Bubble, Drawer-Inhalt und Auto-Open ohne Reload funktionieren. */
  function currentCount() {
    var el = document.querySelector('cart-icon .cart-bubble__text-count, .cart-bubble__text-count');
    var n = el ? parseInt(el.textContent.replace(/\D+/g, ''), 10) : NaN;
    return isNaN(n) ? null : n;
  }

  function notifyCartUpdate(sections, count) {
    var evt = new Event('shopify:cart:lines-update', { bubbles: true });
    evt.action = 'add';
    evt.promise = Promise.resolve({
      cart: { totalQuantity: count },
      detail: { itemCount: count, sections: sections || {}, didError: false }
    });
    document.dispatchEvent(evt);
  }

  /* Zentrale Add-to-Cart-Funktion fuer alle Sassy-Bausteine.
     Bewusst nur EIN Roundtrip: /cart/add.js liefert das gerenderte Drawer-Markup
     gleich mit, also wird sofort damit aktualisiert. Die Zahl im Badge wird
     optimistisch hochgezaehlt und danach im Hintergrund gegen /cart.js
     abgeglichen - sonst wartet der Nutzer auf eine zweite Anfrage, bevor sich
     ueberhaupt etwas bewegt. */
  function addToCart(items) {
    var added = items.reduce(function (sum, i) { return sum + (Number(i.quantity) || 1); }, 0);
    var before = currentCount();
    var pageId = cartPageId();
    var want = pageId ? DRAWER_SECTION + ',' + pageId : DRAWER_SECTION;
    return post('/cart/add.js', { items: items, sections: want })
      .then(function (data) {
        notifyCartUpdate(data && data.sections, before === null ? added : before + added);
        renderCartPage(data && data.sections, pageId);
        reconcileCount();
        return data;
      });
  }

  /* Falls der Warenkorb anderweitig veraendert wurde, Badge still korrigieren. */
  function reconcileCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (currentCount() === cart.item_count) return;
        /* Ueber die Komponente korrigieren statt textContent zu setzen: nur so
           laufen die Badge-Animation und der sessionStorage-Eintrag mit, den
           cart-icon.js beim bfcache-pageshow sonst veraltet wieder anwendet. */
        var icons = document.querySelectorAll('cart-icon');
        var handled = false;
        for (var i = 0; i < icons.length; i++) {
          if (typeof icons[i].renderCartBubble === 'function') {
            /* Die Methode ist async und fasst sessionStorage an, das in
               manchen Browsermodi wirft. Ablehnung hier abfangen, damit sie
               nicht als unbehandelte Promise-Rejection endet. */
            try {
              var p = icons[i].renderCartBubble(cart.item_count);
              if (p && typeof p.catch === 'function') p.catch(function () {});
              handled = true;
            } catch (err) { /* faellt unten auf textContent zurueck */ }
          }
        }
        if (handled) return;
        document.querySelectorAll('cart-icon .cart-bubble__text-count, .cart-bubble__text-count')
          .forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  function openDrawer() {
    /* Auf der Warenkorbseite waere ein Drawer ueber dem Warenkorb nur
       verwirrend - dort hat sich die Seite selbst gerade aktualisiert. */
    if (cartPageId()) return;
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var themeDrawer = document.querySelector('#cart-drawer theme-drawer, theme-drawer#cart-drawer');
    if (themeDrawer && typeof themeDrawer.open === 'function') themeDrawer.open();
  }

  /* --- 1. Quick Add auf Produktkarten --------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sassy-quickadd]');
    if (!btn) return;
    e.preventDefault();
    /* Die Sticky-Leiste ist eine eigene Section und erfaehrt vom Duftwechsel
       oben nichts von selbst. Direkt vor dem Anlegen nachziehen, damit auch
       dann der richtige Duft im Warenkorb landet, wenn der Beobachter unten
       aus irgendeinem Grund nicht angesprungen ist. */
    if (sassySyncSticky && btn.closest('[data-sassy-sticky-atc]')) sassySyncSticky();
    if (btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    /* innerHTML, nicht textContent: das Label enthaelt die Breakpoint-Spans
       ("Quick add" / "Add"), die sonst beim Zuruecksetzen beide sichtbar waeren. */
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var qty = Number(btn.getAttribute('data-quantity')) || 1;
    addToCart([{ id: Number(id), quantity: qty }])
      .then(function () { btn.textContent = 'Added ✓'; openDrawer(); })
      .catch(function () { btn.textContent = 'Try again'; })
      .then(function () {
        setTimeout(function () { btn.disabled = false; btn.innerHTML = label; }, 1600);
      });
  });

  /* --- 2. Mengen-Stepper --------------------------------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-sassy-step]');
    if (!step) return;
    var wrap = step.closest('.sassy-stepper');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = Number(input.min || 1);
    var max = Number(input.max || 99);
    var next = Number(input.value || 1) + (step.getAttribute('data-sassy-step') === 'up' ? 1 : -1);
    input.value = Math.min(max, Math.max(min, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --- 3. Sticky Add-to-Cart ----------------------------- */
  var sticky = document.querySelector('[data-sassy-sticky-atc]');
  var anchor = document.querySelector('[data-sassy-atc-anchor]')
    || document.querySelector('button[name="add"], .add-to-cart-button');
  if (sticky && anchor) {
    /* Bewusst ueber Scroll-Position statt IntersectionObserver: der Anker ist
       nur 1px hoch, und ein flaches Ziel liefert je nach Browser gar kein
       Entry. Die Leiste blendet sich ausserdem aus, sobald der Footer
       auftaucht, damit sie ihn nicht ueberdeckt. */
    var footer = document.querySelector('footer');
    /* Geometrie nur bei Resize messen, nicht pro Scroll-Tick: getBoundingClientRect
       erzwingt ein Layout, und das bei jedem Scroll-Event kostet Frames. */
    var anchorBottom = 0;
    var footerTop = Infinity;
    var measure = function () {
      var y = window.scrollY || window.pageYOffset;
      anchorBottom = anchor.getBoundingClientRect().bottom + y;
      footerTop = footer ? footer.getBoundingClientRect().top + y : Infinity;
    };
    var visible = null;
    var apply = function () {
      var y = window.scrollY || window.pageYOffset;
      var next = y + 10 > anchorBottom && footerTop > y + window.innerHeight;
      if (next !== visible) {
        visible = next;
        sticky.classList.toggle('is-visible', next);
      }
    };
    /* Kein rAF-Wrapper noetig: apply() liest nur noch Zahlen und fasst das DOM
       ausschliesslich an, wenn sich der Zustand wirklich aendert. */
    var onResize = function () { measure(); apply(); };
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    /* Bilder verschieben den Anker beim Nachladen. */
    window.addEventListener('load', onResize);
    measure();
    apply();
  }

  /* --- 3b. Sticky-Leiste an die gewaehlte Variante binden ----------------
     Beim Duftwechsel morpht Horizon nur die Hauptsection. Die Leiste ist eine
     eigene Section und zeigte danach den Start-Duft, verkaufte ihn auch - der
     Kunde bekam also etwas anderes, als oben ausgewaehlt war. Die ID kommt
     deshalb immer aus dem echten Produktformular; Beschriftung, Preis, Bild
     und Verfuegbarkeit stehen in der Variantentabelle am Wurzelknoten. */
  if (sticky) {
    var stickyScope = anchor && anchor.closest ? anchor.closest('.shopify-section') : null;
    if (!stickyScope) {
      var mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
      stickyScope = mainForm && mainForm.closest ? mainForm.closest('.shopify-section') : null;
    }

    var stickyMap = null;
    try {
      var rows = JSON.parse(sticky.getAttribute('data-sassy-sticky-variants') || '[]');
      stickyMap = {};
      for (var si = 0; si < rows.length; si++) stickyMap[String(rows[si].id)] = rows[si];
    } catch (e) { stickyMap = null; }

    var stickyBtn = sticky.querySelector('[data-sassy-quickadd], button[type="submit"]');
    var stickyInput = sticky.querySelector('input[name="id"]');
    var stickyLabel = sticky.querySelector('[data-sassy-sticky-label]');
    var stickyPrice = sticky.querySelector('[data-sassy-sticky-price]');
    var stickyImg = sticky.querySelector('.sassy-sticky-atc__img');

    /* Nur im Hauptformular suchen: die Produktempfehlungen weiter unten
       bringen eigene Formulare mit demselben data-type mit. */
    var liveField = function (name) {
      if (!stickyScope) return null;
      return stickyScope.querySelector('form[data-type="add-to-cart-form"] [name="' + name + '"]');
    };

    if (stickyMap && stickyBtn) {
      sassySyncSticky = function () {
        var field = liveField('id');
        var id = field ? String(field.value || '') : '';
        if (!id) return;
        var row = stickyMap[id];
        /* Eine unbekannte ID entsteht nur, wenn Horizon auf ein anderes
           Produkt umschaltet (verknuepfte Produkte). Dann lieber gar keine
           Leiste als eine, die etwas anderes verkauft, als sie zeigt. */
        if (!row) { sticky.hidden = true; return; }
        sticky.hidden = false;

        if (stickyInput) stickyInput.value = row.id;
        stickyBtn.setAttribute('data-variant-id', String(row.id));

        var qtyField = liveField('quantity');
        var qty = qtyField ? parseInt(qtyField.value, 10) : 1;
        stickyBtn.setAttribute('data-quantity', String(qty > 0 ? qty : 1));

        if (stickyLabel) stickyLabel.textContent = row.label;
        if (stickyPrice) stickyPrice.textContent = row.price;
        if (stickyImg && row.img && stickyImg.getAttribute('src') !== row.img) {
          /* srcset wuerde sonst weiter das alte Bild gewinnen. */
          stickyImg.removeAttribute('srcset');
          stickyImg.setAttribute('src', row.img);
        }

        if (row.available) {
          stickyBtn.disabled = false;
          stickyBtn.setAttribute('data-sassy-quickadd', '');
          stickyBtn.textContent = 'Add to cart';
        } else {
          stickyBtn.disabled = true;
          stickyBtn.removeAttribute('data-sassy-quickadd');
          stickyBtn.textContent = 'Sold out';
        }
      };

      /* Der Beobachter haelt die Anzeige aktuell; die Richtigkeit des
         Warenkorbs haengt nicht an ihm, weil Block 1 vor dem Anlegen ohnehin
         noch einmal nachliest. */
      if (stickyScope && window.MutationObserver) {
        var stickyQueued = false;
        new MutationObserver(function () {
          if (stickyQueued) return;
          stickyQueued = true;
          setTimeout(function () { stickyQueued = false; sassySyncSticky(); }, 0);
        }).observe(stickyScope, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['value']
        });
      }
      sassySyncSticky();
    }
  }

  /* --- 4. Galerie-Thumbnails ----------------------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-sassy-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-sassy-gallery]');
    var main = gallery && gallery.querySelector('[data-sassy-main-image]');
    var img = thumb.querySelector('img');
    if (!main || !img) return;
    main.src = img.getAttribute('data-full') || img.src;
    main.alt = img.alt;
    gallery.querySelectorAll('[data-sassy-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', String(t === thumb));
    });
  });

  /* --- 5. Sort-Select -------------------------------------- */
  var sort = document.querySelector('[data-sassy-sort]');
  if (sort) sort.addEventListener('change', function () {
    var form = sort.closest('form');
    if (form) form.submit();
  });

  /* --- 6. 3-Pack-Builder --------------------------------- */
  var builder = document.querySelector('[data-sassy-builder]');
  if (builder) {
    var size = Number(builder.getAttribute('data-bundle-size') || 3);
    var discount = Number(builder.getAttribute('data-bundle-discount') || 20);
    var messages = JSON.parse(builder.querySelector('[data-bundle-messages]').textContent);
    var picks = [];
    var adding = false;
    var message = function (key, values) {
      var text = messages[key] || '';
      Object.keys(values || {}).forEach(function (name) {
        text = text.split('__' + name + '__').join(String(values[name]));
      });
      return text;
    };
    var selectedPick = function (card) {
      var select = card.querySelector('[data-pick-variant]');
      var option = select && select.options[select.selectedIndex];
      if (!option || !option.value || option.disabled) return null;
      return {
        productId: card.getAttribute('data-pick'),
        id: option.value,
        title: card.getAttribute('data-title'),
        scent: option.textContent.split(' · ')[0],
        image: option.getAttribute('data-image'),
        price: Number(option.getAttribute('data-price'))
      };
    };
    var render = function () {
      var slots = builder.querySelectorAll('[data-slot]');
      slots.forEach(function (slot, i) {
        var pick = picks[i];
        slot.replaceChildren();
        if (pick) {
          var box = document.createElement('div');
          box.className = 'sassy-slot__filled';
          if (pick.image) {
            var img = document.createElement('img');
            img.src = pick.image;
            img.alt = pick.title + ' — ' + pick.scent;
            box.appendChild(img);
          }
          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'sassy-iconbtn sassy-slot__remove';
          remove.setAttribute('data-remove', pick.productId);
          remove.setAttribute('aria-label', message('remove', {product: pick.title}));
          remove.textContent = '×';
          remove.disabled = adding;
          var name = document.createElement('span');
          name.className = 'sassy-slot__name';
          name.textContent = pick.title;
          var scent = document.createElement('span');
          scent.className = 'sassy-slot__scent';
          scent.textContent = pick.scent;
          box.append(remove, name, scent);
          slot.appendChild(box);
        } else {
          var empty = document.createElement('div');
          empty.className = 'sassy-slot__empty';
          empty.textContent = message('empty', {number: i + 1});
          slot.appendChild(empty);
        }
      });
      var full = picks.reduce(function (sum, p) { return sum + p.price; }, 0);
      var complete = picks.length === size;
      var total = complete ? picks.reduce(function (sum, p) {
        return sum + p.price - Math.floor(p.price * discount / 100);
      }, 0) : full;
      var set = function (selector, text) { builder.querySelector(selector).textContent = text; };
      set('[data-total]', money(total));
      set('[data-full]', money(full));
      set('[data-saving]', money(full - total));
      set('[data-count]', message('count', {count: picks.length, size: size}));
      set('[data-status]', complete ? message('ready', {discount: discount}) : message('remaining', {count: size - picks.length, discount: discount}));
      builder.querySelector('[data-savings-group]').hidden = !complete;
      var cta = builder.querySelector('[data-bundle-cta]');
      cta.disabled = adding || !complete;
      cta.textContent = adding ? message('adding') : complete ? message('addSet', {price: money(total)}) : message('pickMore', {count: size - picks.length});
      builder.querySelectorAll('[data-pick]').forEach(function (card) {
        var productId = card.getAttribute('data-pick');
        var on = picks.some(function (p) { return p.productId === productId; });
        var selected = selectedPick(card);
        var blocked = complete && !on;
        var button = card.querySelector('[data-pick-btn]');
        card.classList.toggle('is-picked', on);
        card.querySelector('[data-pick-variant]').disabled = adding;
        button.disabled = adding || blocked || !selected;
        button.setAttribute('aria-pressed', String(on));
        button.textContent = on ? message('inSet') : blocked ? message('full') : selected ? message('add', {price: money(selected.price)}) : message('choose');
        button.className = 'sassy-btn ' + (on ? 'sassy-btn--primary' : 'sassy-btn--pink') + ' sassy-btn--block';
      });
    };
    builder.addEventListener('change', function (event) {
      if (adding || !event.target.matches('[data-pick-variant]')) return;
      var card = event.target.closest('[data-pick]');
      var selected = selectedPick(card);
      if (!selected) return;
      picks = picks.map(function (p) { return p.productId === selected.productId ? selected : p; });
      var img = card.querySelector('.sassy-card__media img');
      if (img && selected.image) {
        img.removeAttribute('srcset');
        img.src = selected.image;
        img.alt = selected.title + ' — ' + selected.scent;
      }
      builder.querySelector('[data-bundle-error]').hidden = true;
      render();
    });
    builder.addEventListener('click', function (event) {
      if (adding) return;
      var remove = event.target.closest('[data-remove]');
      var pickButton = event.target.closest('[data-pick-btn]');
      var cta = event.target.closest('[data-bundle-cta]');
      var error = builder.querySelector('[data-bundle-error]');
      if (remove) {
        var productId = remove.getAttribute('data-remove');
        picks = picks.filter(function (p) { return p.productId !== productId; });
        error.hidden = true;
        render();
        var card = Array.from(builder.querySelectorAll('[data-pick]')).find(function (c) { return c.getAttribute('data-pick') === productId; });
        if (card) card.querySelector('[data-pick-btn]').focus();
      } else if (pickButton) {
        var selected = selectedPick(pickButton.closest('[data-pick]'));
        if (!selected) return;
        var exists = picks.some(function (p) { return p.productId === selected.productId; });
        if (exists) picks = picks.filter(function (p) { return p.productId !== selected.productId; });
        else if (picks.length < size) picks.push(selected);
        error.hidden = true;
        render();
      } else if (cta && picks.length === size) {
        adding = true;
        error.hidden = true;
        render();
        addToCart(picks.map(function (p) {
          return {id: Number(p.id), quantity: 1, properties: {_bundle: 'sassy-' + size + 'pack'}};
        })).then(function () {
          window.location.href = builder.getAttribute('data-bundle-cart-url');
        }).catch(function (err) {
          adding = false;
          render();
          error.textContent = err && typeof err.description === 'string' ? err.description : message('error');
          error.hidden = false;
        });
      }
    });
    render();
  }

  /* ---------- 7. Hover-Bildwechsel auf Produktkarten ------------------- */
  /* Das zweite Bild steht im Markup nur als URL. Erst wenn eine echte Maus
     die Karte beruehrt, entsteht daraus ein <img>. Auf Touchgeraeten passiert
     dadurch gar nichts: kein Request, kein Knoten, keine Bytes. Auch auf dem
     Desktop laedt nur, was wirklich angefahren wird. */
  var sassyCanHover = null;
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    if (sassyCanHover === null) {
      sassyCanHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    }
    if (!sassyCanHover) return;
    var card = e.target.closest && e.target.closest('.sassy-card[data-sassy-hover]');
    if (!card) return;
    var url = card.getAttribute('data-sassy-hover');
    /* Attribut entfernen ist die Einmal-Sperre - kein Set, kein WeakMap. */
    card.removeAttribute('data-sassy-hover');
    var base = card.querySelector('.sassy-card__media img');
    if (!url || !base) return;
    var img = new Image();
    img.className = 'sassy-card__hover';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.decoding = 'async';
    if ('fetchPriority' in img) img.fetchPriority = 'low';
    /* Dasselbe srcset/sizes wie das Hauptbild: das Hoverbild fuellt exakt
       denselben Kasten. Ohne das laedt ein Bildschirm ohne Retina die
       doppelte Groesse. */
    if (/width=\d+/.test(url)) {
      var widths = [200, 300, 400, 600, 800];
      var set = [];
      for (var w = 0; w < widths.length; w++) {
        set.push(url.replace(/width=\d+/, 'width=' + widths[w]) + ' ' + widths[w] + 'w');
      }
      img.srcset = set.join(', ');
      var baseSizes = base.getAttribute('sizes');
      if (baseSizes) img.sizes = baseSizes;
    }
    img.addEventListener('load', function () { img.classList.add('is-ready'); });
    img.src = url;
    /* In den <a> haengen, nicht ans .sassy-card__media: der Quick-Add-Button
       steht spaeter im DOM und soll weiter darueber liegen. */
    (base.parentNode || card).appendChild(img);
  });

  /* ---------- 8. Scroll-Reveal ---------------------------------------- */
  /* Versteckt wird ausschliesslich unter .sassy-reveal-on, und diese Klasse
     setzt ein winziges Inline-Skript im <head> (layout/theme.liquid) noch vor
     dem ersten Paint. Zwei Konsequenzen, beide gewollt:
       - Faellt JS aus, greift keine Versteck-Regel. Nichts bleibt unsichtbar.
       - Es gibt kein Aufblitzen: der Startzustand steht vor dem ersten Paint
         fest, statt von diesem defer-Skript nachtraeglich gesetzt zu werden. */
  if (document.documentElement.className.indexOf('sassy-reveal-on') > -1 &&
      'IntersectionObserver' in window) {
    var reveal = document.querySelectorAll('.sassy-reveal');
    if (reveal.length) {
      var ioDelivered = false;
      var io = new IntersectionObserver(function (entries) {
        ioDelivered = true;
        for (var k = 0; k < entries.length; k++) {
          if (!entries[k].isIntersecting) continue;
          entries[k].target.classList.add('is-in');
          io.unobserve(entries[k].target);
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

      /* Sicherheitsnetz. Der Observer liefert nur, solange die Seite wirklich
         gerendert wird - in einem Hintergrundtab bleibt er stumm. Normalerweise
         holt er das beim Sichtbarwerden nach. Hat er nach vier Sekunden aber gar
         nichts geliefert, geben wir alles frei: lieber ohne Animation als auch
         nur eine Sektion, die unsichtbar haengen bleibt. */
      setTimeout(function () {
        if (ioDelivered) return;
        for (var n = 0; n < reveal.length; n++) reveal[n].classList.add('is-instant', 'is-in');
      }, 4000);

      /* Erst alle Positionen lesen, dann alle Klassen setzen. Gemischt wuerde
         jeder Durchlauf ein erneutes Layout erzwingen. */
      var vh = window.innerHeight;
      var tops = [];
      var m;
      for (m = 0; m < reveal.length; m++) tops.push(reveal[m].getBoundingClientRect().top);
      for (m = 0; m < reveal.length; m++) {
        /* Was schon sichtbar ist, wird ohne Uebergang freigegeben - sonst
           blendet sich Inhalt ein, den der Nutzer bereits ansieht. */
        if (tops[m] < vh) reveal[m].classList.add('is-instant', 'is-in');
        else io.observe(reveal[m]);
      }
    }
    /* Entwarnung an den Notausgang im <head>: der Reveal-Code ist komplett
       durchgelaufen, es kann nichts mehr unsichtbar haengen bleiben. Steht
       bewusst am Ende - wirft der Block vorher, greift der Notausgang. */
    window.sassyRevealReady = true;
  }

  /* ---------- 9. 3-Pack-Fortschritt: ein Blitz bei 100 % --------------- */
  /* Der Drawer wird per Section Rendering API gemorpht, im Markup ueberlebt
     also keine Klasse. Der "war schon voll"-Zustand liegt deshalb hier in der
     Closure: kein Neuaufbau kann den Blitz ein zweites Mal ausloesen.
     MutationObserver statt Promise-Kette, weil auch Horizons eigene Mengen-
     schalter im Drawer den Stand aendern, ohne durch unseren Code zu laufen. */
  var drawerRoot = document.getElementById('cart-drawer');
  if (drawerRoot && window.MutationObserver) {
    var packFull = function () {
      var p = drawerRoot.querySelector('[data-sassy-pack]');
      return !!p && p.getAttribute('data-pack-complete') === 'true';
    };
    var packWas = packFull();
    new MutationObserver(function () {
      var now = packFull();
      if (now && !packWas) {
        var track = drawerRoot.querySelector('.sassy-drawer__track');
        if (track) {
          track.classList.add('is-complete');
          setTimeout(function () { track.classList.remove('is-complete'); }, 700);
        }
      }
      packWas = now;
    }).observe(drawerRoot, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-pack-complete']
    });
  }
})();

